import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import HTMLDisplay from "../../../utils/HTMLDisplay";
import truncate from "truncate-html";
import image_search from "../../../assets/img/images.png";
import image_illustration from "../../../assets/img/illustration.png";
import "../../../assets/css/SearchResultSection.css";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const YOUTUBE_URL = process.env.REACT_APP_YOUTUBE_URL;
const GOOGLE_URL = process.env.REACT_APP_GOOGLE_URL;
// const itemsPerPage = 2;
// const readPerPage = 50;
// const downloadsPerPage = 5;

function SearchResultSection({
  datacontent,
  downloadSection,

  pagination,
  setPageRead,
  paginationDownload,
  setPageDownload,
}) {
  // PAGINATION
  const changePage = (page) => {
    if (pagination && page >= 1 && page <= pagination.last_page) {
      // Save current scroll position
      const scrollPosition = window.scrollY;

      setPageRead(page);

      // Restore scroll after render
      setTimeout(() => {
        window.scrollTo({
          top: scrollPosition,
          behavior: "instant",
        });
      }, 50);
    }
  };

  const changePageDownload = (page) => {
    if (
      paginationDownload &&
      page >= 1 &&
      page <= paginationDownload.last_page
    ) {
      // Save current scroll position
      const scrollPosition = window.scrollY;

      setPageDownload(page);

      // Restore scroll after render
      setTimeout(() => {
        window.scrollTo({
          top: scrollPosition,
          behavior: "instant",
        });
      }, 50);
    }
  };

  function getRandomWholeNumber(max) {
    return Math.ceil(Math.random() * max);
  }
  const TruncateHtml = (htmlString, length) => {
    return truncate(htmlString, length, { byWords: true });
  };
  return (
    <section id="service-details" className="service-details section">
      <div className="container">
        <div className="row gy-4">
          {/* MAIN CONTENT */}
          <div className="col-lg-8" data-aos="fade-up" data-aos-delay={200}>
            {datacontent.map((service, index) => {
              const date = new Date(service.daterqw);
              const month = date
                .toLocaleString("default", { month: "short" })
                .toUpperCase();
              const day = date.getDate();
              const year = date.getFullYear();
              const addressLink = service.addressLink
                ? service.addressLink.split("*Locat*")
                : [];

              const passport = service.passport
                ? service.passport.split(".")
                : [];

              return (
                <>
                  <div className="display-section">
                    <div className="row pb-4">
                      <div className="col-lg-8">
                        <h3
                          className="card-title text-uppercase pt-2 pb-0 text-success"
                          style={{ textAlign: "justify" }}
                        >
                          {service.columes !== "title_advert_utube" && (
                            <Link
                              to={`/read/${service.id}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ textAlign: "justify" }}
                              className="text-secondary"
                            >
                              <HTMLDisplay
                                html={service.story01}
                                textNo={""}
                                type="title"
                              />
                            </Link>
                          )}

                          {(service.columes === "title_advert_utube" ||
                            service.columes === "title_show_echo_01wa") && (
                            <Link
                              to={
                                addressLink[1] === "youtube"
                                  ? `${YOUTUBE_URL}${addressLink[0]}`
                                  : `${GOOGLE_URL}${addressLink[0]}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              loading="lazy"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowfullscreen
                            >
                              {service.title}
                            </Link>
                          )}
                        </h3>
                        <p className="card-text" style={{ flexGrow: 1 }}>
                          <Link
                            to={`/read/${service.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textAlign: "justify" }}
                            className="text-secondary"
                          >
                            <HTMLDisplay
                              html={service.story01}
                              textNo={20}
                              type="body"
                            />
                          </Link>
                        </p>
                      </div>
                      <div className="col-lg-4">
                        {service.passport && (passport[1] ? "jpg" : "png") && (
                          <div className="position-relative mb-2">
                            {service.passport &&
                              service.passport !== "undefined" &&
                              service.passport !== "null" &&
                              service.passport.trim() !== "" && (
                                <>
                                  <img
                                    loading="lazy"
                                    decoding="async"
                                    src={`${BACKEND_URL}upload/${service.passport}`}
                                    alt={service.title || "Image"}
                                    className="card-img-top rounded-0"
                                    style={{
                                      objectFit: "cover",
                                      height: "auto",
                                      width: "100%",
                                    }}
                                  />
                                </>
                              )}

                            <div className="vertical-date-badge">
                              <div className="date-part">{month}</div>
                              <div className="date-divider">—</div>
                              <div className="date-part vertical-formatDate">
                                {day}
                              </div>
                              <div className="date-divider">—</div>
                              <div className="date-part">{year}</div>
                            </div>
                          </div>
                        )}

                        {service.columes === "title_advert_utube" && (
                          <div className="position-relative mb-2">
                            <div className="card h-100 shadow border-0">
                              <div className="position-relative mb-2">
                                <iframe
                                  width="100%"
                                  height="300"
                                  src={
                                    addressLink[1] === "youtube"
                                      ? `${YOUTUBE_URL}${addressLink[0]}`
                                      : `image_search`
                                  }
                                  title={service.title}
                                  loading="lazy"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowfullscreen
                                ></iframe>
                              </div>
                            </div>
                            <div className="vertical-date-badge">
                              <div className="date-part">{month}</div>
                              <div className="date-divider">—</div>
                              <div className="date-part vertical-formatDate">
                                {day}
                              </div>
                              <div className="date-divider">—</div>
                              <div className="date-part">{year}</div>
                            </div>
                          </div>
                        )}

                        {service.columes === "title_show_echo_01wa" && (
                          <div className="position-relative mb-2">
                            <div className="card h-100 shadow border-0">
                              <div className="position-relative mb-2">
                                <Link
                                  to={`${BACKEND_URL}upload/${service.addressLink}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {service.passport &&
                                    service.passport !== "undefined" &&
                                    service.passport !== "null" &&
                                    service.passport.trim() !== "" && (
                                      <>
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          src={image_illustration}
                                          alt={service.title || "Image"}
                                          style={{
                                            width: "100%",
                                            height: "200px",
                                            objectFit: "cover",
                                          }}
                                        />
                                      </>
                                    )}
                                </Link>
                              </div>
                            </div>
                            <div className="vertical-date-badge">
                              <div className="date-part">{month}</div>
                              <div className="date-divider">—</div>
                              <div className="date-part vertical-formatDate">
                                {day}
                              </div>
                              <div className="date-divider">—</div>
                              <div className="date-part">{year}</div>
                            </div>
                          </div>
                        )}

                        {service.caption && (
                          <small className="text-muted mb-0 blockquote-footer">
                            <em style={{ textAlign: "justify" }}>
                              <HTMLDisplay
                                html={service.caption}
                                textNo={10}
                                type="title"
                                className="text-secondary"
                                // textSize="0.8rem"
                              />
                            </em>
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
            {/* PAGINATION */}

            {/* Pagination Controls */}
            <div className="d-flex justify-content-end align-items-center mt-3">
              <button
                className="btn btn-dark me-2"
                onClick={() => changePage(1)}
                disabled={pagination?.current_page === 1}
              >
                «
              </button>

              <button
                className="btn btn-dark me-2"
                onClick={() => changePage(pagination?.current_page - 1)}
                disabled={pagination?.current_page === 1}
              >
                ‹
              </button>

              <span className="me-2">
                Page {pagination?.current_page} of {pagination?.last_page}
              </span>

              <button
                className="btn btn-dark me-2"
                onClick={() => changePage(pagination?.current_page + 1)}
                disabled={pagination?.current_page === pagination?.last_page}
              >
                ›
              </button>

              <button
                className="btn btn-dark"
                onClick={() => changePage(pagination?.last_page)}
                disabled={pagination?.current_page === pagination?.last_page}
              >
                »
              </button>
            </div>
          </div>

          {/* LEFT SIDEBAR (ONLY FOR CENTER) */}
          <div className="col-lg-4" data-aos="fade-up" data-aos-delay={100}>
            {/* DOWNLOADS }*/}
            <div className="highlight-box mb-4" data-aos="fade-up">
              <div className="highlight-title">Downloadable Resources</div>
              <ul className="list-unstyled mb-0">
                {downloadSection.map((file, i) => (
                  <li key={i}>
                    <i className="bi bi-file-earmark-arrow-down-fill me-2"></i>
                    <Link
                      className="text-capitalize"
                      to={`${BACKEND_URL}upload/${file.addressLink}`}
                      download
                      target="_blank"
                    >
                      <span className="row">
                        <span className="col-lg-1">
                          <i className="fas fa-file-pdf me-2 fs-5 text-danger"></i>
                        </span>
                        <span className="col-lg-10 text-capitalize">
                          {TruncateHtml(file.title, 12)}
                        </span>
                        {/* <span className="col-lg-1 text-end">
                          <i className="fas fa-download fs-5"></i>
                        </span> */}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
              {/* DOWNLOAD PAGINATION */}

              {/* Pagination Controls */}
              <div className="d-flex justify-content-end align-items-center mt-3">
                <button
                  className="btn btn-dark me-2"
                  onClick={() => changePageDownload(1)}
                  disabled={paginationDownload?.current_page === 1}
                >
                  «
                </button>

                <button
                  className="btn btn-dark me-2"
                  onClick={() =>
                    changePageDownload(paginationDownload?.current_page - 1)
                  }
                  disabled={paginationDownload?.current_page === 1}
                >
                  ‹
                </button>

                <span className="me-2">
                  Page {paginationDownload?.current_page} of{" "}
                  {paginationDownload?.last_page}
                </span>

                <button
                  className="btn btn-dark me-2"
                  onClick={() =>
                    changePageDownload(paginationDownload?.current_page + 1)
                  }
                  disabled={
                    paginationDownload?.current_page ===
                    paginationDownload?.last_page
                  }
                >
                  ›
                </button>

                <button
                  className="btn btn-dark"
                  onClick={() =>
                    changePageDownload(paginationDownload?.last_page)
                  }
                  disabled={
                    paginationDownload?.current_page ===
                    paginationDownload?.last_page
                  }
                >
                  »
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default React.memo(SearchResultSection);
